import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { deleteChatroomMessage } from '../../../../api'
import { QA_NAME_CONFIRMATION } from '../../../../constants/qa'
import { useNotification, useUserData } from '../../../../hooks'
import { isApiNotFoundStatus } from '../../../../utils/api'
import { ConfirmationModal } from '../../../Confirmation'
import { getChatroomMessageDeletedUpdate } from '../ChatroomMessage.utils'

export function useChatroomMessageDelete({
  message,
  outboundUuid,
  onDeleted,
  onNotFound,
  onUpdateMessage,
}) {
  const { t } = useTranslation()

  const currentUser = useUserData()

  const { handleAddErrorNotification } = useNotification()

  const [isConfirmationOpen, setConfirmationOpen] = useState(false)
  const [isDeleting, setDeleting] = useState(false)

  function handleClickDelete() {
    setConfirmationOpen(true)
  }

  function handleCloseConfirmation() {
    setConfirmationOpen(false)
  }

  function markDeleted() {
    onDeleted?.()
    onUpdateMessage?.(
      message.uuid,
      getChatroomMessageDeletedUpdate({
        currentUserId: currentUser?.id,
        message,
      })
    )
  }

  async function handleSubmitDelete() {
    setDeleting(true)

    return deleteChatroomMessage({ outboundUuid, uuid: message.uuid })
      .then(response => {
        if (response) {
          markDeleted()
        }
      })
      .catch(error => {
        // A 404 means someone else already deleted the message.
        if (isApiNotFoundStatus(error?.response?.status)) {
          onNotFound?.()
          markDeleted()
        } else {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        }
      })
      .finally(() => {
        setDeleting(false)
        handleCloseConfirmation()
      })
  }

  const deleteConfirmationModal = isConfirmationOpen ? (
    <ConfirmationModal
      actionButtonsProps={{ submitText: t('Modal.DeleteBtnKey') }}
      description={t('Chatroom.MessageDeleteConfirmationKey')}
      loading={isDeleting}
      qaName={QA_NAME_CONFIRMATION}
      onCancel={handleCloseConfirmation}
      onSubmit={handleSubmitDelete}
    />
  ) : null

  return { deleteConfirmationModal, handleClickDelete }
}
